// Catálogo de plantillas de paneles + constantes compartidas (visibilidad, rangos relativos)

export const VISIBILITY_OPTIONS = [
  { value: "private", label: "Privado (solo yo)" },
  { value: "shared_view", label: "Todos pueden ver" },
  { value: "shared_edit", label: "Todos pueden ver y editar" },
  { value: "custom", label: "Usuarios específicos" },
];

export const visibilityLabel = (panel) => {
  const v = panel.visibility || (panel.is_shared ? "shared_view" : "private");
  return VISIBILITY_OPTIONS.find((o) => o.value === v)?.label || v;
};

export const RELATIVE_RANGES = [
  { value: "", label: "Todo el tiempo" },
  { value: "today", label: "Hoy" },
  { value: "7d", label: "Últimos 7 días" },
  { value: "30d", label: "Últimos 30 días" },
  { value: "90d", label: "Últimos 90 días" },
  { value: "this_month", label: "Este mes" },
  { value: "last_month", label: "Mes pasado" },
  { value: "this_quarter", label: "Este trimestre" },
  { value: "last_quarter", label: "Trimestre pasado" },
  { value: "this_year", label: "Este año" },
];

export const PANEL_TEMPLATES = [
  {
    id: "pipeline_overview",
    name: "Vista general del pipeline",
    description: "Foto completa del pipeline: cantidad y valor de negocios, embudo por etapa, carga por propietario y tendencia mensual.",
    audience: "Gerentes y supervisores que necesitan ver el estado global del pipeline de un vistazo.",
    reports: [
      { key: "kpi_total", title: "Cantidad de negocios", type: "kpi", metric: "count", w: 3, h: 3 },
      { key: "kpi_valor", title: "Valor total del pipeline", type: "kpi", metric: "sum_value", w: 3, h: 3 },
      { key: "kpi_ponderado", title: "Valor ponderado", type: "kpi", metric: "weighted_value", w: 3, h: 3 },
      { key: "funnel", title: "Embudo por etapa", type: "funnel", metric: "count", w: 6, h: 5 },
      { key: "bar_owner", title: "Negocios por propietario", type: "bar_by_owner", metric: "count", w: 6, h: 5 },
      { key: "line_mes", title: "Tendencia mensual de creación", type: "line_by_month", metric: "count", w: 6, h: 5 },
    ],
  },
  {
    id: "team_performance",
    name: "Rendimiento del equipo",
    description: "Compara la producción por vendedor: cantidad, valor ganado, tasa de conversión y metas.",
    audience: "Líderes comerciales que dan seguimiento al desempeño individual del equipo.",
    reports: [
      { key: "bar_owner_count", title: "Negocios por propietario", type: "bar_by_owner", metric: "count", w: 6, h: 5 },
      { key: "bar_owner_won", title: "Valor ganado por propietario", type: "bar_by_owner", metric: "won_value", w: 6, h: 5 },
      { key: "kpi_rate", title: "Tasa de conversión", type: "kpi", metric: "won_rate", w: 3, h: 3 },
      { key: "goal", title: "Meta vs Logrado", type: "goal_vs_actual", metric: "won_value", w: 6, h: 5 },
    ],
  },
  {
    id: "sales_summary",
    name: "Resumen de ventas",
    description: "Resultados de cierre: valor y cantidad de ganados, motivos de pérdida y evolución mensual del valor.",
    audience: "Dirección y gerencia comercial para revisión mensual de resultados.",
    reports: [
      { key: "kpi_won_value", title: "Valor ganado", type: "kpi", metric: "won_value", w: 3, h: 3 },
      { key: "kpi_won_count", title: "Negocios ganados", type: "kpi", metric: "won_count", w: 3, h: 3 },
      { key: "donut_lost", title: "Motivos de pérdida", type: "donut", metric: "count", group_by_field: "lost_reason", w: 6, h: 5 },
      { key: "line_valor", title: "Valor creado por mes", type: "line_by_month", metric: "sum_value", w: 6, h: 5 },
    ],
  },
  {
    id: "close_index",
    name: "Índice de cierre",
    description: "Ganadas vs perdidas vs abiertas, embudo del proceso y cierre por propietario (como el panel del video de referencia).",
    audience: "Supervisores que monitorean la efectividad de cierre por vendedor.",
    reports: [
      { key: "pie_status", title: "Ganadas / Perdidas / Abiertas", type: "pie_by_field", metric: "count", group_by_field: "status", w: 6, h: 5 },
      { key: "bar_owner_wc", title: "Ganadas por propietario", type: "bar_by_owner", metric: "won_count", w: 6, h: 5 },
      { key: "kpi_rate", title: "Tasa de conversión", type: "kpi", metric: "won_rate", w: 3, h: 3 },
      { key: "funnel", title: "Embudo por etapa", type: "funnel", metric: "count", w: 6, h: 5 },
    ],
  },
];
